import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import { useState, useCallback, useEffect } from 'react';
import { isSSR } from '../utils/isSSR.js';

var lockTimeout;

var clearLockTimeout = function clearLockTimeout() {
  if (lockTimeout !== undefined) {
    clearTimeout(lockTimeout);
    lockTimeout = undefined;
  }
};

var useScrollLock = function useScrollLock() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    defaultLock: false
  };

  var _useState = useState(Boolean(options.defaultLock)),
      _useState2 = _slicedToArray(_useState, 2),
      isLock = _useState2[0],
      setLock = _useState2[1];

  var lock = useCallback(function () {
    clearLockTimeout();
    lockTimeout = setTimeout(function () {
      setLock(true);
      lockTimeout = undefined;
    }, 300);
  }, []);
  var unlock = useCallback(function () {
    clearLockTimeout();
    setLock(false);
  }, []);
  useEffect(function () {
    var _context;

    if (isSSR()) {
      return;
    } // preact/compat: always need function return


    if (!isLock) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return function () {};
    }

    var html = document.documentElement;
    var _document = document,
        body = _document.body;
    var scrollTop = window.pageYOffset || html.scrollTop || body.scrollTop || 0;
    var el = document.createElement('style');
    el.id = 'tux-screen-lock';
    el.innerHTML = _concatInstanceProperty(_context = "\n        html {\n          height: 100%;\n          overflow: hidden;\n        }\n        body {\n          ".concat(scrollTop > 0 ? 'height: auto;' : '', "\n          min-height: 100%; /* for ios 12 */\n          top: -")).call(_context, scrollTop, "px;\n          left: 0;\n          right: 0;\n          overflow: hidden;\n          position: fixed;\n        }\n      ");
    body.appendChild(el);
    body.setAttribute('tux-screen-lock-offset', "-".concat(scrollTop));
    return function () {
      clearLockTimeout();

      if (body.querySelector('#tux-screen-lock') !== null) {
        body.removeChild(el);
      }

      if (body.hasAttribute('tux-screen-lock-offset')) {
        body.removeAttribute('tux-screen-lock-offset');
      }

      if ('scrollBehavior' in html.style) {
        var elm = document.createElement('style');
        elm.innerHTML = "\n          html, body {\n            scroll-behavior: auto !important;\n          }\n        ";
        body.appendChild(elm);
        window.scrollTo({
          top: scrollTop,
          behavior: 'auto'
        });
        body.removeChild(elm);
      } else {
        window.scrollTo(0, scrollTop);
      }
    };
  }, [isLock]);
  return {
    isLock: isLock,
    lock: lock,
    unlock: unlock,
    setLock: setLock
  };
};
var getBodyFixedTopOffset = function getBodyFixedTopOffset() {
  if (isSSR()) {
    return;
  }

  if (!document.body.hasAttribute('tux-screen-lock-offset')) {
    return;
  }

  var screenLockOffset = _parseInt(document.body.getAttribute('tux-screen-lock-offset') || '0', 10);

  return screenLockOffset;
};

export { getBodyFixedTopOffset, useScrollLock };
//# sourceMappingURL=useScrollLock.js.map
